export const integraTecXTPStrings = {
  title: "DuPont™ IntegraTec™ XTP 100 IG",
  productName: "IntegraTec™ XTP 100 IG",
};
